import { MonetaryAmount } from "../../../../currency/currencyTypes"

export enum CurrencyCode {
    DKK = "DKK",
}

export enum ShopType {
    POS = "POS",
    MEETING_SERVICE = "MEETING_SERVICE",
    SUBSCRIPTION = "SUBSCRIPTION",
}

export type MerchantSalesReportData = Readonly<{
    startDate: string
    endDate: string
    reportTime: string
}>

export type MerchantSalesMerchants = Readonly<{
    id: number
    uid: string
    caseNumber: string
    name: string
    address: {
        displayName: string
    }
    bookedSales: MonetaryAmount
    upcomingSales: MonetaryAmount
}>

export type Account = Readonly<{
    name: string
    bookedSales: MonetaryAmount
    upcomingSales: MonetaryAmount
}>

export type Category = Readonly<{
    name: string
    accounts: ReadonlyArray<Account>
    totalBookedSales: MonetaryAmount
    totalUpcomingSales: MonetaryAmount
}>

type SalesByAccount = Readonly<{
    categories: ReadonlyArray<Category>
}>

export type MerchantSalesMerchantsDetails = Readonly<{
    id: number
    uid: string
    caseNumber: string
    name: string
    addressDisplayText: string
    salesByAccount: SalesByAccount
}>

export type MerchantSalesMerchantsForExport = Readonly<{
    id: number
    caseNumber: string
    name: string
    salesByAccount: SalesByAccount
}>
